import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import colors from "../styles/colors";

type ButtonProps = {
  to: string;
  text: string;
  className?: string;
};

const Button: React.FC<ButtonProps> = ({ to, text, className = "" }) => {
  const navigate = useNavigate();

  return (
    <motion.button
      onClick={() => navigate(to)}
      className={`px-6 py-3 border-2 shadow-xl text-lg md:text-xl rounded-xl font-serif transition-opacity duration-300 ${className}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.3 }}
      transition={{ duration: 1, delay: 0.5 }}
      style={{
        backgroundColor: colors.darkBrown,
        color: colors.lightCream,
        borderColor: colors.darkBrown,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = colors.pastelCream;
        e.currentTarget.style.color = colors.darkBrown;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = colors.darkBrown;
        e.currentTarget.style.color = colors.pastelCream;
      }}
    >
      {text}
    </motion.button>
  );
};

export default Button;
